module.exports = __webpack_public_path__ + "static/img/guian.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guian.png
// module id = nlC1
// module chunks = 1